"use client";

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closePopup } from "../../redux/slices/popupSlice";
import "./GlobalPopup.styles.scss";
import ThankYouPopup from "../Popups/ThankYouPopup";
import Image from "next/image";
import CitiesPopup from "../Popups/CitiesPopup";
import LeadForm from "../Forms/LeadForm";
import CalculateEmi from "../CalculateEmi";
const GlobalPopup = () => {
  const dispatch = useDispatch();
  const { currentPopupId, popupData } = useSelector((state) => state.popups);
  const popupComponents = {
    thankYouPopup: ThankYouPopup,
    citiesPopup: CitiesPopup,
    leadFormPopup: LeadForm,
    leadFormPopup2: LeadForm,
    calculateEmi: CalculateEmi,
  };

  const PopupContent = currentPopupId ? popupComponents[currentPopupId] : null;

  if (!PopupContent) return null;

  const enableButtons = currentPopupId === "leadFormPopup" ? true : false;
  const showPopupHeading = (currentPopupId === "leadFormPopup" || currentPopupId === "leadFormPopup2") ? true : false;

  return (
    <div className="popup-overlay">
      <div className="popup-content-container">
        <button onClick={() => dispatch(closePopup())} className="close-popup">
          <Image
            src="https://assets.turnoclub.com/developer/innovolt/icons/cross-icon.svg"
            alt="cancel"
            width={20}
            height={20}
          />
        </button>
        <div className="popup-content">
          <PopupContent {...popupData} showButtons={enableButtons} showPopupHeading={showPopupHeading} />
        </div>
      </div>
    </div>
  );
};
export default GlobalPopup;
